import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=494eca3b&scoped=true&lang=pug&"
import script from "./HeaderNavigation.vue?vue&type=script&lang=js&"
export * from "./HeaderNavigation.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNavigation.vue?vue&type=style&index=0&id=494eca3b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494eca3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
